export default function useProjectsData() {
  function importAll(r) {
    return r.keys().map(r);
  }

  const feldman = importAll(require.context("../feldman/", false, /\.(webp)$/));
  const fink = importAll(require.context("../fink/", false, /\.(webp)$/));
  const goetsch = importAll(require.context("../goetsch/", false, /\.(webp)$/));
  const kucera = importAll(require.context("../kucera/", false, /\.(webp)$/));
  const ostov = importAll(require.context("../ostov/", false, /\.(webp)$/));
  const su = importAll(require.context("../su/", false, /\.(webp)$/));

  return [
    {
      id: "feldman",
      images: feldman,
      name: "Talya Feldman",
      bio: `
# 1990

geboren in Denver, Colorado USA

# 2022

Studium der Bildenden Künste, Hochschule für Bildende Künste Hamburg bei Prof. Simon Denny
Abschluss Master of Fine Arts

# 2013

Studium der Bildenden Künste an der School of the Art Institute of Chicago, USA
Abschluss Bachelor of Fine Arts
      `,
      exhibitionsSingle: `


# 2023
„Elegy“
Kunstmuseen Erfurt

# 2023
„And Our Cities Change“,
Eigen+Art Lab, Berlin

# 2022
„Cut from Blue Sky“,
Vera Munro Gallery, Hamburg

# 2022
„Wir Sind Hier“,
Hochschule für bildende Künste, Hamburg

# 2021
„Wir Sind Hier“,
Kunstverein in Hamburg, KV.Digital

# 2021
„After Halle“,
Jüdisches Museum Frankfurt, Frankfurt am Main

# 2021 – 2023
„The Violence We Have Witnessed Carries a Weight on Our
Hearts“,

Jüdisches Museum Berlin, Berlin;

Künstlerhaus 188 e. V., Halle; Hanse-Schule
Wirtschaft & Verwaltung, Lübeck;

Dietrich-Keuning-Haus, Dortmund

# 2020
„Elegy [Excerpt]“,
Jüdisches Museum Frankfurt, Frankfurt am Main

# 2020
„Global White Supremacist Terror: Halle“, 
Digital Platform, NSU-Watch

# 2020
„Together/Apart: In Memory of Potta Géza and Dzsuga Géza“, 
Denver, USA
      `,
      exhibitionsGroup: `


# 2023
„Wer wir sind / Who We Are“,
Bundeskunsthalle, Bonn

# 2022
Jahresausstellung,
Hochschule für bildende Künste, Hamburg

# 2021
„Darkness“,
frappant e.V., Hamburg

# 2021
„memory is a social organ“,
fffriedrich, Frankfurt am Main

# 2020
„After One Year“,
Raum der Erinnerung und Solidarität, Halle

# 2020
Jahresausstellung,
Hochschule für bildende Künste, Hamburg

# 2020
„Dearly Disillusioned: In the Making“,
McNichols Civic Center, Denver, CO, USA`,
      jury: `
Im Fokus von Talya Feldmans Multimedia-Forschung stehen
alternative Erzählungen zu Gewalt. Nicht die allgemein
verbreitete Sicht der Täter, Medien, Justiz, sondern die meist
ausgeschlossenen Stimmen der Opfer, Überlebenden,
Angehörigen der Getöteten macht sie in ihren Video- und
Audioinstallationen physisch erlebbar. Sie erzeugen neue Narrative und entwerfen eine andere Realität.
Indem sie die Stärke und den Widerstand dieser Gemeinschaften hervorhebt, ist ihre Arbeit ein Akt des Aufbegehrens. Ein mutiger Kampf für
Recht auf Erinnerung.

„Ich will leben, wie ich es mir wünsche. Schmerzlos, ohne
Sorgen. Ich will lieben, geliebt werden, wie es sich mein Herz
erträumt (...)“ ist eine Stimme auf der digitalen Plattform und
der gleichnamigen Videoinstallation _„WIR SIND HIER“_ (2022)
zu hören. Es ist ein Auszug aus einem der 350 Gedichte der
türkischen Migrantin Semra Ertan, die sich 1982 aus Protest
gegen Rassismus öffentlich verbrannte. Die unmittelbar vor
ihrem Suizid drastisch zunehmende Ausländerfeindlichkeit wird
von statistischen Angaben unterstützt. Seit ihrem Tod fordern
Ertans Familie und die Initiative In Gedenken an Samra Ertan
die Umbenennung der Kreuzung Simon-von-Utrecht-Straße/Detlev-Bremer-Straße in Hamburg, in der sie sich anzündete, um ihr angemessen zu gedenken. Die Kraft der
Vielstimmigkeit ertönt auch in der zweistündigen 18-Kanal-Klanginstallation _THE VIOLENCE WE HAVE WITNESSED CARRIES A WEIGHT ON OUR HEARTS_ (2021) und vermittelt
eindringlich sehr individuelle persönliche Geschichten rechter
Gewalt in Deutschland seit 1979, die sich zum kollektiven
Widerstand von Überlebenden und Familien von Opfern
verbinden.

In ihrer jüngsten Arbeit *GRIEF IS DATA: CUT FROM BLUE SKY* (2022) greift die Künstlerin Daten aus dem Gun Violence
Archive des Bundesstaates Colorado auf. Mit unterschiedlichen
Blautönen bemalte Aluminiumplatten zeigen klein gedruckte,
rechteckige Tabellen, die Auskunft über die Opferzahlen von 15
Massenerschießungen seit 2021 geben. In einem Gedicht
definiert Victoria Chang Trauer als aus dem Himmel
geschnittene Rechtecke. So symbolisiert die Form des
Rechtecks, sowohl der Platten als auch der Fakten, in
zweifacher Hinsicht Leid, Schmerz und Narben der
Hinterbliebenen.

*ANNA NOWAK*, Jurymitglied
`,
      projects: [
        {
          title: "Wir sind hier: Burak Bektaş",
          description: `2022

3-channel video projections with video and sound material from the digital archive, WIR SIND HIER. Ein digitaler Raum für individuelle und kollektive Trauer und Widerstand. A digital space for individual and collective mourning and resistance

28 min`,
          image: feldman[0],
        },
        {
          title: "GRIEF IS DATA: CUT FROM BLUE SKY",
          description: `2022

Oil on 15 aluminium plates

30x45 cm each`,
          image: feldman[1],
        },
        {
          title:
            "THE VIOLENCE WE HAVE WITNESSED CARRIES A WEIGHT ON OUR HEARTS",
          description: `2021

18-channel sound installation mounted on scaffold netting, digital smartphones

120 min

Foto: Yves Sucksdorff, Jüdisches Museum Berlin`,
          image: feldman[2],
        },
        {
          title: "ELEGY",
          description: `
2020

Film still

6:25 min
`,
          image: feldman[3],
        },
        {
          title: "AFTER ONE YEAR",
          description: `2020

Film still
      
26:00 min`,
          image: feldman[4],
        },
        {
          title: "WHITE SUPREMACIST TERROR: HALLE",
          description: `
2020

Film still from the digital platform

[Video](https://halle.nsu-watch.info/)
      `,
          image: feldman[5],
        },
      ],
    },
    {
      id: "fink",
      images: fink,
      name: "Michael Fink",
      bio: `
# 1993 
geboren in Bolzano, IT

# SEIT 2018
Studium der Malerei an der Kunsthochschule Berlin Weißensee bei Prof. Friederike Feldmann
`,
      exhibitionsSingle: `


# 2024				
Gallery Vacancy, Shanghai, CN
      `,
      exhibitionsGroup: `


# 2023
„Card Rack“, 
Museumsshop Museion Bozen, IT

# 2023
„Art SG“, 
Vacancy Gallery, SG

# 2022
„Inventur“, 
Kunsthalle am Hamburger Platz, Berlin

# 2022
„On The Verge“,
Wetterling Gallery, Stockholm, SE

# 2022
„Art Antwerp“, 
Newchild Gallery, Antwerpen, BE

# 2021
„Happy Place“, 
Stall Display, Berlin

# 2021
„Cave Canem“, 
Eve Leibe Gallery, London, GB

# 2021
„Visual Unpredictability“, 
Patrick Parrish Gallery, New York, USA

# 2019
„Einwandfrei“,
Stall Display, Berlin
      `,
      jury: `
In seiner Malerei, wie auch in seinen verschiedenen medienbasierten Arbeiten und Installationen erkundet Michael Fink die Bildräume klassischer Porträtmalerei und von Landschaftsdarstellungen, um sie mit neuen Bildinhalten jenseits anthropozentrischer Weltvorstellungen zu füllen. Perspektivwechsel und Durchlässigkeit von Erfahrungsräumen, in denen sich die Grenzen zwischen Menschen und Tieren, Pflanzen und Zellstrukturen wie auch zwischen natürlicher und künstlicher Intelligenz (KI) auflösen, stehen im Zentrum von Michael Finks eigenwilliger künstlerischer Bildforschung. Welche Rolle spielt Empathie für unsere Evolution? Wie sieht die Welt aus der Perspektive einer Pflanze aus und wie können wir diese als eine von uns, als einen mit der Menschheit kollaborierenden Akteur in einer jahrhundertewährenden Koexistenz erkennen? Der Riesenbärenklau, bei Michael Fink als phantastisch expressives Fabelwesen in *GIANT MOVING* (2022) porträtiert, ist ein Doldenblüter, der, ursprünglich im Kaukasus beheimatet, heute zu den invasivsten und zugleich giftigsten botanischen Spezies Mitteleuropas gehört. In der Forst- und Landwirtschaft lange Zeit als nützlich geltende Pflanze definiert, gilt er heute als hemerochor, das heißt seine Ausbreitung ist ganz wesentlich kulturellen Faktoren zu verdanken. In Michael Finks Arbeit *CARD RACK (GREETING CARDS)* (2022) entwirft die KI idealtypische unberührte Landschaften. Seine aus Ölmalerei und Siebdruck bestehende Serie *IT’S NOT ME, IT’S YOU (PATTERN PAINTINGS)* (2021/2022) lädt uns ein, den Blick durch innere Landschaften, in diesem Fall stark vergrößerte Zellstrukturen, schweifen zu lassen. Seltsam direkt sehen uns die porträtierten Pferde seiner Gemäldeserie *LOCALS REUNION (PORTRAIT PAINTINGS)* (2021/2022) an, Fabelwesen mit menschlichen Lippen, aus einer Vergangenheit, in der Menschen und Pferde noch eine Sprache geteilt haben müssen. Welche Sprache sprechen Bakterien im Kompost? Unter anderem durch Donna Haraway als radikale Vordenkerin eines neuen und zugleich uralten Bewusstseins inspiriert, leisten Michael Finks Malerei, Medienarbeiten und Installationen auf seltsam direkte Weise Übersetzungsarbeit. Mit seinen Erkundungsreisen in neue Bildwelten lädt er uns ein, Verwandtschaften jenseits menschlicher Familienbande neu zu entdecken.

*CHRISTIANE MENNICKE-SCHWARZ*, Jurymitglied
      `,
      projects: [
        {
          title: "GIANT MOVING 02",
          description: `2022

Öl auf Leinwand

210 cm x 190 cm`,
          image: fink[0],
        },
        {
          title: "WRAPS 01",
          description: `
2021

Costume Paintings
Öl auf Leinwand

230 cm x 190 cm`,
          image: fink[1],
        },
        {
          title: "A PICTURE OF A SCENE",
          description: `2022

Native Mansion
      
Öl auf Leinwand
      
180 cm x 210 cm`,
          image: fink[2],
        },
        {
          title: "CLUSTER FRAMEWORKS",
          description: `
2022

Native Mansion

Acryl auf Leinwand

140 cm x 110 cm`,
          image: fink[3],
        },
        {
          title: "IT’S NOT ME, IT’S YOU",
          description: `2022

Pattern Paintings
 
Öl auf Leinwand
 
190 cm x 160 cm`,
          image: fink[4],
        },
        {
          title: "LOCAL‘S REUNION",
          description: `2022
Portrait Paintings

Öl auf Leinwand
      
180 cm x 120 cm
      
Ausstellungsansicht Wetterling Gallery; On the Verge`,
          image: fink[5],
        },
      ],
    },
    {
      id: "goetsch",
      images: goetsch,
      name: "Rahel Goetsch",
      bio: `
# 1993
geboren in Oldenburg

# 2018 - 2023 	
Studium der Bildenden Kunst an der Städelschule Frankfurt am Main bei Prof. Judith Hopf

# 2013 - 2018
Studium der Visuellen Kommunikation an der Weißensee Kunsthochschule Berlin 
Abschluss Bachelor of Arts
      `,
      exhibitionsSingle: `


# 2021		
Nightly Cares
SCHLEUSE 
Kunst- und Kulturstiftung Opelvillen Rüsselsheim

# 2021		
„Playing with Fire“, 
Zusammenarbeit mit Manuel Tayarani
sonneundsolche Düsseldorf
      `,
      exhibitionsGroup: `


# 2022		
„Loops and Breakthroughs“
Magma Maria, Offenbach

# 2022	
„Zeit“ 
House of Spouse, Wien, AT

# 2022	
„Comic Relief“
Spoiler, Berlin

# 2022	
„Another Dimension“ 
Oranienstraße 161, Berlin

# 2022	
„Grand Nizza Show“ 
Hotel Nizza, Frankfurt am Main

# 2021
Kunstpreis „junger westen“
Kunsthalle Recklinghausen (Katalog)

# 2021
„+1“
TOR Art Space, Frankfurt am Main

# 2021
„Going Nowhere“
Spoiler, Berlin

# 2021
„Frankfurter Kunst Vertrieb“
  Magma Maria, Frankfurter Kunstverein, 
Frankfurt am Main

# 2020
„COVID19 DIARIES“ 
Lovaas Projects, München 

# 2019
„Puzzle Days“
Basis, Frankfurt am Main

# 2018
Absolventenausstellung
Direktorenhaus, Berlin

# 2017
„Schnittstelle“
Kunsthalle am Hamburger Platz, Berlin

# 2017
„HECKE“
Kunstpunkt Berlin (Katalog)

# 2017
„Zeichensprachen“
Galerie Parterre, Berlin (Katalog)

# 2015
„Schlamassel“
Bezalel Academy of Arts and Design, 
Jerusalem, IL 
      `,
      jury: `
Goetschs Praxis widmet sich immer wieder Räumen der Intimität und des Häuslichen, die sie meist mithilfe des Mediums der Zeichnung sowie durch die Beschäftigung mit der Linie erforscht – und die von Zeit zu Zeit auch in die dritte Dimension übergehen.

Rahel Goetschs Ausstellung *NIGHTLY CARES* (2021) umfasst eine Reihe von überdimensionalen Zahnbürsten, die, wie durch wiederholten Gebrauch, abgenutzt sind. Ihre Form hat etwas Alltägliches, Gewöhnliches – es handelt sich um das grundlegendste Werkzeug der täglichen Körperpflege – und doch eröffnet sich im Schatten ihrer verschlissenen Gestalt eine Möglichkeit: Die Größe und das Gewicht dieser Skulpturen sowie ihr roher Zustand sind weder selbstverständlich noch beständig. 

In ähnlicher Weise enthalten die Fensterformen in Goetschs Arbeit die Sicherheit und Klarheit von Linie und Struktur, gleichzeitig finden sich darin aber auch Momente, welche die Linie nicht zu fassen vermag: Farbfelder oder Notationen, die außerhalb und zwischen klassischen Abgrenzungen auftauchen. Goetschs Arbeit scheint einer genauen Beobachtung folgend auf einen intimeren Bereich des Alltäglichen zu verweisen, der mit einer sorgfältigen Aufmerksamkeit das formuliert, was nicht explizit gesagt oder benannt wird. In den durchgestrichenen Sprechblasen von *NOT LISTENING* (2022) beobachten wir einen Augenblick des abgebrochenen Austauschs zwischen zwei abstrahierten Figuren. Es ist unklar, ob es sich bei diesen Gesprächen um Szenarien tatsächlicher Konfrontation handelt oder, vielleicht noch heimtückischer, um Personen, die zwar miteinander sprechen, bei denen aber dieser Raum der Verbindung, des Empfangens des anderen nicht (mehr) vorhanden ist. 

Goetschs Werk ist immer auch von einer unterschwelligen Einsamkeit gezeichnet, die nahegeht und vielleicht in ihrer schüchternen Natur eher skizziert und umrissen als eingefangen und benannt werden muss.

*FATIMA HELLBERG*, Jurymitglied      
`,
      projects: [
        {
          title: "ON BOTH ENDS",
          description: `
2022

brünierter Stahl und Latex

variable Maße

Foto: Ivan Murzin`,
          image: goetsch[0],
        },
        {
          title: "OHNE TITEL",
          description: `
2021

Zeichnung Graphitpulver und Tusche

100 x 420 cm

Foto: Ivan Murzin`,
          image: goetsch[1],
        },
        {
          title: "CANDY LOVER (A) & CANDY LOVER (F)",
          description: `
2021

Holz, Lack, Lasur und PVC-Borsten

250 x 20 x 30 cm

Foto: Ivan Murzin`,
          image: goetsch[2],
        },
        {
          title: "ZWISCHENBILANZEN II & IV",
          description: `
2020

Tusche, Bleistift und Ölstick auf Papier

je 230 x 115 cm

Foto: Ivan Murzin`,
          image: goetsch[3],
        },
        {
          title: "LOOPING LESSONS I",
          description: `
2019

Ölstick auf Papier

140 x 230 cm

Foto: Ivan Murzin`,
          image: goetsch[4],
        },
        {
          title: "WAITING FOR YOU WAITING FOR ME",
          description: `
2022

Holzschnitt

120 x 180 cm

Foto: Tomás Maglione`,
          image: goetsch[5],
        },
      ],
    },
    {
      id: "kucera",
      images: kucera,
      name: "Hanna Kučera",
      bio: `
# 1996 
geboren in Hildesheim

# SEIT 2021
Studium der Critical Studies an der Akademie für Bildende Künste Wien, AT

# 2015 - 2021 	
Studium der Bildenden Kunst an der Hochschule für Bildende Künste Dresden bei Prof. Christian Sery in der Fachklasse „Experimentelle und interdisziplinäre Malerei“
Abschluss Diplom

# 2021 - 2022		
Meisterschülerin bei Prof. Christian Sery, Hochschule für Bildende Künste Dresden

# 2020 	
Auslandssemester an der Academy of Fine Arts Prag in der Fachklasse „Intermedia II“, CZ

# SEIT 2018 	
Studium der Bildenden Kunst an der Akademie für Bildende Künste Wien bei Prof. Monica Bonvicini, aktuell Prof. Iman Issa, in der Fachklasse „Sculpture and Space Strategies“

# 2018 	
Auslandssemester an der Universität für Angewandte Kunst Wien, AT, bei Prof. Hans Schabus in der Fachklasse „Sculpture and Space“ 
`,
      exhibitionsSingle: `


# 2017					 
„Refresh, it’s so fresh“, 
Ex14, Dresden      
`,
      exhibitionsGroup: `


# 2022
„On the Road Again – Modular Nature Barrier“, Performative Intervention in Paul Spendiers skulpturaler Installation im österreichischen Kulturforum Washington, D.C., USA

„What is left to steal“, Forum Frohner, Donaufestival Krems, AT

„Einrichtung und Gegebenheit: Infrastruktur als Form und Handlung“, Exhibit Galerie
Eschenbachgasse, Wien, AT

# 2021 	
„Made by Desire“, The Wrong Bienale No. 5, Internet

„Open Plan Living“, Hortus, Wien, AT

# 2020 	
„Genealogie der Dinge“, Kunstverein Kärnten, Künstlerhaus, Klagenfurt, AT

# 2019 	
„SOLANI DULCAMARAE“, Phyllis Johnson, Leipzig

„Heap of Rubble Bubble“ in Kollaboration mit Schimmel Projects, Current, Mailand, IT

# 2018 	
„An Intersection does not exist, if lines run parallel“, Skulpturinstitut, Wien, AT

„Dgtl Fmnsm“, Festspielhaus Hellerau, Dresden      
      `,
      jury: `
Hanna Kučeras künstlerische Praxis ist eine Verflechtung unterschiedlicher Disziplinen, für die sie ein ganz eigenes System schafft. Das gleichzeitige Bestehen von Ausdrucksformen wie Sprache und Musik, Kostüm und Plastik, Installation und Szenografie sind dabei zentral. Hierfür hat sich ein autarkes Vokabular entwickelt. Die einzelnen Elemente, meistens selbst produziert, sowie auch Akteur\\*innen nennt sie „Player“. Sie treffen auf andere Player in den eigens kreierten sogenannten „Plays“. In den Plays gibt es parafiktionale Positionen („Pos.“), in denen verschiedene Player in Interaktion miteinander treten; diese sind wiederum in „Acts“ gegliedert. Texte, Skulpturen, Objekte und Kleidung stehen gleichwertig nebeneinander und fügen sich oftmals zu raumgreifenden Installationen. Die Akteur\\*innen sind eingeladene Künstler\\*innen, die Figuren und Klangstücke in den Plays reinterpretieren. So erarbeitet Kučera situationsbezogene, handlungsbetonte und dadurch ephemere Interventionen, die sie bis ins Detail durchdekliniert. Besonders daran ist der ganzheitliche, analytische Ansatz. Als eine Art Erweiterung der Performance entsteht ein spielerisches, hybrides und kollaboratives Miteinander ohne bestimmtes Ziel und feste Spielregeln. 

„I am I, and I am you, and you are them, as we are us, and they are I, as we are them,“ ertönt es in *THIS MUST BE THE PLAY, POS. 13, MIRROR, MIRROR* (2021) und betont auch auf sprachlicher Ebene, dass jede Position für sich steht und zugleich mit allen anderen verbunden ist. Mit dem Begriff der „Idiorrhythmie“ erfasst Roland Barthes 1976/77 die Gleichzeitigkeit von individueller Gestaltung und Gemeinschaftsbildung. Diese Überschneidung spiegelt sich auch in Kučeras transdisziplinärer Praxis wider. Prozesse der bewusst schöpferischen Auseinandersetzung mit Arbeit und Spiel sind ihre Kernthemen sowie das kritische Hinterfragen von Machtstrukturen und Wissensordnungen. In der Intervention *POS. 16 PERFORMING PROFESSIONALITY ACT II ELEVATION* (2022) sitzt die Künstlerin selbst an einem Stahltisch, den Oberkörper abgelegt, in einem verglasten Fahrstuhl. Jedes Mal, wenn Besucher*innen das Fahrzeug per Knopfdruck betätigen, erhebt sie sich ruckartig und betrachtet sich selbst im Spiegel. Wie in einem Selbstgespräch prüft sie künstlerisches Handeln und das ambivalente Spannungsfeld vom Künstler\\*innen-Subjekt als arbeitenden oder spielenden Part. Teil der Inszenierung sind mit weiteren Künstler\\*innen abgeschlossene Verträge aus dem vorangehenden Akt *WELCOME TO MY OFFICE* (2021). Befestigt an den Aufzugswänden verdoppeln sie sich in der Spiegelung und verweisen einerseits auf den diskursiven, vielstimmigen Raum und fragen andererseits nach Autorenschaft und Gleichwertigkeit in kollaborativen Schaffensabfolgen.

*ANNA NOWAK*, Jurymitglied
            
`,
      projects: [
        {
          title: "KLAMMER SAMT",
          description: `
2020

Foto der Player in skulpturaler Installation des 60 minütigen Plays

Player v.l. nach r. Nana Dahlin, Kristyna Nytrova, Rogine Moradi, Hanna Kučera, Hedda Bauer

Stahlstrukturen, Aluminium, Leder, Textilien, PVC, Samt, tragbare Teile, Score aus zusammengenähtem Transparentpapier, Maulkörbe, Technik, Text, Sound, Maße variabel

Bildhauerstandort der Akademie der Bildenden Künste Wien

Foto © Igor Blomberg Tranaeus

[Videodokumentation](https://hannakucera.com/klammer-samt-2)`,
          image: kucera[0],
        },
        {
          title: "„POS. 14 STRUCTURES ACT II WOLF IM SCHAFSPELZ“",
          description: `
2022

Skulpturale Installation

Player: Stahl, Schafwolle Maße variabel

Kleiner Steinsaal des Bildhauerstandortes der Akademie der Bildenden Künste Wien

Foto © Hanna Kučera`,
          image: kucera[1],
        },
        {
          title: "THIS MUST BE THE PLAY",
          description: `
Diplom 2021

Still der Videodokumentation des 60 minütigen Plays in skulpturaler Installation

Player: Jessica Comis, Kenneth Constance Loe, Kristyna Nytrova, Hanna Kučera

Hüpfburg 400 x 400 x 400 cm produziert von Guangzhou Planet Inflatables Ltd., Tragbare Teile aus PVC, Textil, Tüll, Leder, Silikon, Pigmente, Stahl, Gebläse, Soundsystem, Mikrofone, Booklets Maße der Installation variabel Oktogon

HfBK Dresden Videodokumentation „This must be the Play“

2021, gefilmt von Leon Michel: [Video](https://hannakucera.com/This-must-be-the-Play-BP)`,
          image: kucera[2],
        },
        {
          title: "„POS. 16 PERFORMING PROFESSIONALITY ACT III TRANSPOSITION“",
          description: `
Still der Videodokumentation der 40 min. Intervention in skulpturaler Installation

Player: Kristyna Nytrova, Hanna Kučera, Headset Mikrofone, Tragbare Teile, Sound,
Kameras, Gadgets, Technik, Gitterstrukturen aus Stahl, tragbare Teile, Skript und
Zeichnungen auf handgemachtem Papier mit Pflanzeneinschlüssen umschlossen von
Silikon, PVC, Baustrahler Maße variabel

Videodokumentation gefilmt von Juliana Lindenhofer und Michael Reindel

Choreographie in Kollaboration mit Kristyna Nytrova

Gruppenausstellung „Einrichtung und Gegebenheit: Infrastruktur als Form und
Handlung“ Exhibit Eschenbachgasse, Wien
`,
          image: kucera[3],
        },
        {
          title: "„POS. 16 PERFORMING PROFESSIONALITY ACT V MOBILITIES“",
          description: `
2022

Still aus der 30 min. performativen Intervention in Paul Spendiers Installation „On The Road - Modular Barrier“

Player: Hanna Kučera, Kleid von Marlene Haase, Paul Spendiers Installation aus Brombeerästen, Magneten und Stahlkugeln, Stahl, Headset Mikrophon, Kontaktmikrophone, Sound

Österreichisches Kulturforum Washington D.C. USA

Videodokumentation gefilmt von Paul Spendier: [Video](https://hannakucera.com/Act-V-Mobilities-BP)
        `,
          image: kucera[4],
        },

        {
          title: "POS. 16 PERFORMING PROFESSIONALITY ACT V MOBILITIES",
          description: `
2022

Fotodokumentation der 30 min. performativen Intervention in Paul Spendiers Installation „On The Road - Modular Barrier“

Player: Hanna Kučera, Kleid von Marlene Haase, Paul Spendiers Installation aus Brombeerästen, Magneten und Stahlkugeln, Stahl, Headset Mikrophon, Kontaktmikrophone, Sound

Fotos © ACF DC Österreichisches Kulturforum Washington D.C. USA

Videodokumentation gefilmt von Paul Spendier: [Video](https://hannakucera.com/Act-V-Mobilities-BP)`,
          image: kucera[5],
        },
      ],
    },
    {
      id: "su",
      images: su,
      name: "Su Yu Hsin",
      bio: `
# 1989 
born in Taichung, TW

# since 2019 
Academy of Fine Arts Leipzig Media Art 
Expanded Cinema Class
Prof. Clemens von Wedemeyer

# 2017 - 2019 
Vordiplom at Academy of Fine Arts Leipzig 
Media Art

# 2012 - 2013 
Post Experience Programme Royal College of Art 
Visual Communication

# 2008 - 2012 
Bachelor of Fine Arts Shih Chien University 
Communications Design 3D Animation`,
      exhibitionsSingle: ` 

					 
# 2022 
„Wet Mechanics of Seeing“, 
Kunsthalle Winterthur, Winterthur, CH

# 2021 
„frame of reference“, 
alexander levy, Berlin

# 2019 
„Another Order of Time“, 
TAV Barry Room, Taipei, TW

„hibernatemode“, 
Fenko Hidden Chamber, Taipei, TW
`,
      exhibitionsGroup: `


# 2022 
„Paeonia Drive“, Taipei Arts Festival x BLEED, 
Taipei Performing Arts Center, TW

„Futur 21 - kunst industrie kulture festival“, 
LWL Henrichshütte Hattingen (K)

# 2021
„Sustainable Museum: Art and Environment“, 
MOCA Busan, Busan, KR (K)

„Toi et moi, on ne vit pas sur la même planète“, 
Centre Pompidou-Metz, Metz, FR

„Baroque Topologies“, 
Kunstverein Leipzig, Leipzig

„The Rearview Landscape, or a Trip of Ownership“, 
UCCA Dune Art Museum, CN (K)

# 2020 
„Taipei Biennial You and I Don’t Live on the Same Planet“, 
TFAM, Taipei, TW (K)

„Critical Zones“, 
ZKM Karlsruhe, Karlsruhe (K)

„In the Era of Asia’s Post-LCC“, 
Kyoto Art Center, Kyoto, JP

# 2019
„Flaneur Festival“ 
Haus der Kulturen der Welt, Berlin

      `,
      jury: `
Su Yu Hsin ist eine Künstlerin und Filmemacherin. Ihre Praxis kreist um Fragestellungen der Ökologie, der sie sich insbesondere durch den Einsatz von Technologie nähert. Wie betrachten wir die Dinge? Und von welchem Standpunkt aus? Wo befindet sich der Körper der beobachtenden Person in dieser Infrastruktur und wie kann er nach innen blicken? Diese Fragen und Auseinandersetzungen sind wesentlich für ihre Praxis.

Sus Bewegtbildinstallationen und -performances sind das Ergebnis umfangreicher Recherchen, in denen sie sich vor Ort begibt, um einen Raum physisch zu erfassen und zu kartieren. Gleichzeitig werden aber auch das filmische Medium sowie die Mittel der Repräsentation und Vermittlung an sich reflektiert. Sie beschäftigt sich mit Räumen der Verbindung, in denen es kein Außen gibt: In ihren Untersuchungen stark politisierter Belange, wie der Ökologie des Wassers, fließt und sickert die Thematik buchstäblich durch die Kategorien Politik, Geografie, soziale Anliegen und Strukturen der Ungleichheit.

Bezeichnenderweise verbindet Su ihre Untersuchungen darüber hinaus mit einem fortwährenden Dialog mit dem Imaginären, mit dem Erzählen von Geschichten. Sie geht der Frage nach, wie eine Auseinandersetzung mit Themen, die zwischen Mikro- und Makroebene oszillieren, auf eine Weise navigiert werden kann, die auch Perspektiven der Intimität, der Instabilität sowie der Entfremdung und des Bruchs einbezieht. Innerhalb dieser Beziehungen fungiert bei Su Technologie als zentrales Bindeglied und als Schnittpunkt zwischen Kräften, die zwar von Menschenhand geschaffen wurden, aber dennoch oft zu sehr miteinander verwoben, unübersichtlich und allumfassend sind, um einfach dort zu enden. Su setzt verschiedenste Geräte zur Ortung, Kartierung und Darstellung nicht nur ein, sondern eröffnet auch die Möglichkeit, die angenommene Neutralität unserer Wissensapparate zu hinterfragen.

*FATIMA HELLBERG*, Jurymitglied      
      `,
      projects: [
        {
          title: "FRAME OF REFERENCE I & II",
          description: `
2021

Ausstellungsansicht, Video Installation

Full HD, 11:10 min, 4:30 min, 2h 41:00 min, Dimensions Variable

Foto: Trevor Good`,
          image: su[0],
        },
        {
          title: "MORI",
          description: `
2021

Ausstellungsansicht, Video Installation 

Full HD, 21:45 min, Dimension Variable

Foto: Kai Hu
        `,
          image: su[1],
        },
        {
          title: '"WATER SLEEP II AKAIKE RIVER UNDER XIZANG ROAD"',
          description: `
2019

Filmstill, Experimental Film

Full HD, 10:24 min
        `,
          image: su[2],
        },
        {
          title: "HIBERNATEMODE",
          description: `
2019

Ausstellungsansicht, Video Installation

Full HD, 16:00 min, Dimension Variable

Foto: Achim Kukulies
        `,
          image: su[3],
        },
        {
          title: "TIDAL VARIATIONS",
          description: `
2021

Ausstellungsansicht, Video Installation 

Full HD, 14:40 min, Dimension Variable

Foto: Christian Schwager
          `,
          image: su[4],
        },
        {
          title: "PAEONIA DRIVE",
          description: `
2022

Ausstellungsansicht, Multimedia Performance

Foto: Wade Cherng
        `,
          image: su[5],
        },
      ],
    },
    {
      id: "ostov",
      images: ostov,
      name: "óstov collective",
      bio: `
# 12.03.22
Gründung des Kollektivs, Leipzig
      `,
      exhibitionsSingle: `
# 15.03. – 15.04.22 	
„Gruppentherapie für Ukrainer*innen“, HGB Leipzig 

# 10.04.22 		
„Support Ukrainian Artists“ Print Sale, 
HGB Leipzig 

# 10.04.22 	
Vortragsprogramm / Interviews mit Nikita Kadan, Valeria Schiller, Maria Isserlis & Anastasiya Levchuk, 
HGB Galerie, Leipzig
  
# 15.04. – 10.12.22 	
„Tryzúb-T-Shirt“, 
Kollaboration mit Stanis.Slav 

# 22.04. – 24.04.22 
„ЗЛАМ / ZLAM“, 
Plast Space, Leipzig 

# 22.04.22 	
„Support Ukrainian Artists”, Print Sale, Plast Space, Leipzig 

# 31.07. – 17.08.22 	
„Sensing Places / Placing Senses“, 
ODP Galerie, Leipzig
  
# 26.08. – 31.12.22	 	
„ЗЛАМ / ZLAM“, 
Circles of War, 
Hochbunker Grüner Hof, Köln 

# 26.08. – 15.04.23 	
„ЗЛАМ / ZLAM“, Sound-Installation, Ostpassage, Ebertplatz, Köln 

# 16.09.22 		
„Support Ukrainian Artists”, Print Sale, Re:Ukraine, Conne Island, Leipzig 

# 02.12 – 10.12.22
„Магазин! UA Temporary Store“,
Sleeve++, Leipzig 

# 26.01.23 		
„ЗЛАМ / ZLAM“, „Radical Receptionist‽”, HGB Galerie, Leipzig
  
# 26.01.23 	
„Sit down tragedy: About horizontal connections in Ukrainian society“,

„Radical Receptionist‽”, HGB Galerie, Leipzig
      `,
      exhibitionsGroup: ``,
      jury: `
Mit dem Óstov Collective zeichnet die Jury die künstlerisch-kollaborative Praxis eines ukrainisch-deutschen Künstle\\*innen-Kollektivs aus, das sich wenige Wochen nach Beginn des russischen Angriffskriegs gegen die Ukraine in Leipzig gegründet hat. Die Gruppe – derzeit im Kern Elza Gubanova, Anna Perepechai, Leon Seidel und Emilia Sladek – hat in Zeiten massiver Verunsicherung durch die Gewalt des Kriegs neue Formen für eine prozessgeleitete und auf Teilhabe basierende ästhetische Praxis entwickelt. Mit künstlerischen Solidaritätsaktionen, Vortragsreihen, der Schaffung von diversen Plattformen für künstlerischen Austausch, psychosozialen Angeboten, Ausstellungen, Performances sowie aktivistischen Interventionen hat das Óstov Collective ein beeindruckendes Beispiel für eine ganzheitliche künstlerische Praxis vorgestellt. So beinhaltet zum Beispiel die partizipative Soundinstallation *ЗЛАМ (‘ZLAM)* (2022) eine Sammlung von über 100 Audioaufnahmen von Umgebungsgeräuschen, die dem Kollektiv im Zuge eines Open Calls von Ukrainer*innen zugesandt wurden. In Form einer begehbaren Installation vermitteln die vielen Audioschnipsel eine klangliche Synthese individueller Erfahrungen – ohne dabei ihren historischen Charakter einzubüßen. 

In den Projekten gelingt es auf herausragende Weise, radikal subjektiven ästhetischen Verarbeitungen der traumatischen Erfahrungen von Displacement, Verlust und individueller Trauer eine jeweils eigene Form zu geben sowie Räume für Empathie, Empowerment und Verständigung jenseits vereinfachender Polarisierungen zu eröffnen.

Beeindruckt hat uns als Jury der Mut des Künstler*innen-Kollektivs, inmitten einer noch ungeklärten Situation eine prozessorientierte künstlerisch-kuratorische Kollaboration ins Zentrum ihrer Arbeit zu stellen sowie sich auf der Basis von Empathie und Sensibilität aktiv für Freiheit und Demokratie einzusetzen. 

*CHRISTIANE MENNICKE-SCHWARZ*, Jurymitglied
      `,
      projects: [
        {
          title: "ЗЛАМ / ZLAM",
          description: `
2022

Soundinstallation

Materialien & Format variabel

Plast Space, Leipzig, DE
        `,
          image: ostov[0],
        },
        {
          title: "МАГАЗИН! UA TEMPORARY STORE",
          description: `
2022

Schaufensteransicht

Sleeve++, Leipzig, DE
        `,
          image: ostov[1],
        },
        {
          title: "ЗЛАМ / ZLAM",
          description: `
2022

Soundinstallation

Materialien & Format variabel

Circles of War, Hochbunker Grüner Hof, Köln, DE
        `,
          image: ostov[2],
        },
        {
          title: "ЗЛАМ / ZLAM",
          description: `
2022

Soundinstallation

Materialien & Format variabel

Radical Receptionist‽, HGB Galerie, Leipzig, DE`,
          image: ostov[3],
        },
        {
          title: "SENSING PLACES / PLACING SENSES, AUSSTELLUNGSANSICHT",
          description: `
2022

Kuratorisches Projekt

Malerei, Fotografie, Skulptur, Siebdruck, Zeichnung, Collage, Video

Unterschiedliche Formate

ODP Galerie, Leipzig, DE
          `,
          image: ostov[4],
        },
        {
          title: "ÓSTOV TABLE, AUSSTELLUNGSANSICHT",
          description: `
2022

Stahl, Holz, Glas, Dokumente, Polaroids, gefundene Objekte, Sound

125 x 80 cm
        
HGB Leipzig, Leipzig, DE
        `,
          image: ostov[5],
        },
      ],
    },
  ].map((w) => ({
    ...w,
    portrait: require(`../portraits/${w.id}.webp`),
    projects: w.projects.map((p, idx) => ({ ...p, id: `${w.name}-${idx}` })),
    firstname: w.name.split(" ")[0],
    lastname: w.name.split(" ").slice(1).join(" "),
  }));
}
